import i18n from 'i18n';
import { useContext, useEffect, useRef, useState } from 'react';
import { Typography } from '@mui/material';
import { getVerifiedTemplateFullInfo } from 'services/getVerifiedTemplateFullInfo';
import { logError } from 'services/Logger';
import { Message } from 'services/types';
import ChatsContext from 'contexts/chats/context';
import { DateSeparator } from 'components/MessagesList/styled';
import { convertSeparatorToDate, formatDate } from 'helpers/formatterDates';
import { ReactComponent as Loading } from '../../../assets/icons/loadingYalo.svg';
import Header from './Header/Header';
import NotificationMessage from './NotificationMessage/NotificationMessage';
import { ChatContainer, MainArea, MessagesArea, MessagesWrapper, LoadingWrapper } from './styled';

const Notification = () => {
  const [messages, setMessages] = useState<Message[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const containerRef = useRef(null);
  const { notificationSelected } = useContext(ChatsContext);
  const getTemplateInfo = async () => {
    setIsLoading(true);
    try {
      const templateInfo = await getVerifiedTemplateFullInfo(notificationSelected?.lastMessage?._id || '');
      const {
        data: { Messages },
      } = templateInfo;
      setMessages(Messages);
    } catch (error) {
      logError('Error fetching template info', error);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    if (notificationSelected?.lastMessage?._id) {
      getTemplateInfo();
    }
  }, [notificationSelected?.lastMessage?._id]);

  const formattedDate = formatDate(
    convertSeparatorToDate(notificationSelected?.lastMessage.ts.split('T')[0] || ''),
    i18n.language
  );
  return (
    <ChatContainer data-testid="chatNotificationContainer">
      <div>
        <Header contactName={notificationSelected?.fname || ''} />
      </div>
      <MainArea>
        {isLoading && (
          <LoadingWrapper data-testid="loadingWrapper">
            <Loading />
          </LoadingWrapper>
        )}
        {messages.length > 0 && (
          <MessagesWrapper>
            <MessagesArea ref={containerRef} key={notificationSelected?._id}>
              <DateSeparator>
                <Typography variant="caption1">{formattedDate}</Typography>
              </DateSeparator>
              {messages.map((message) => (
                <NotificationMessage {...message} createdAt={notificationSelected?.lastMessage.ts || ''} />
              ))}
            </MessagesArea>
          </MessagesWrapper>
        )}
      </MainArea>
    </ChatContainer>
  );
};

export default Notification;
